// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumb_breadcrumbs__Ukecm","loadingCrumb":"Breadcrumb_loadingCrumb__65zK5"};